import React from 'react';

import PostCard from './Post';

const PostComments = ({ parentId, comments, onDelete }) => (
  <div className="ml-24 sm:ml-6">
    {Array.isArray(comments) &&
      comments.length > 0 &&
      comments.map((comment) => {
        const replies = comments.filter(
          ({ parentId }) => parentId === comment.id
        );
        return (
          <>
            <PostCard
              key={comment.id}
              isComment={true}
              parentId={parentId}
              preview={false}
              onDelete={onDelete}
              {...comment}
            />
            {replies.length > 0 && (
              <div className="pl-6">
                {replies.map((reply) => (
                  <PostCard
                    key={reply.id}
                    preview={false}
                    isComment={true}
                    onDelete={onDelete}
                    {...reply}
                  />
                ))}
              </div>
            )}
          </>
        );
      })}
  </div>
);

export default PostComments;
